import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { ChangeMajorActivity } from 'containers/forms/dashboard'
import { MaterialModal } from 'components/layout'

export default class ChangeMajorActivityModal extends Component {
  static propTypes = {
    modalId: PropTypes.string,
  }

  render() {
    const { modalId } = this.props

    return (
      <MaterialModal.Body
        id={modalId}
        title='Select your Major Activity'
        titleKey='moduleTitle.select_your_major_activity'
      >
        <MaterialModal.Content>
          <ChangeMajorActivity {...this.props} />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
